export default {"src":"/uk/_next/static/media/piggyBankIcon.dc9c3947.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};